import React from "react";

import "./Skills.css";
const Boxes = (props) => {
  return (
    <div>
      <div className="skills-box">
        <div className="box-icon">{props.icon}</div>
        <div>
          <img src={props.image} className="box-image" />
        </div>
        <div className="box-content">
          <div className="box-heading">{props.heading}</div>
          <div className="box-text">{props.text}</div>
        </div>
      </div>
    </div>
  );
};

export default Boxes;
